import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import type { ResApplicantDetail } from '@/lib/queries/business/v1/types'

export const createApplicantMutation = {
  mutationFn: (data: { name: string; email: string; phone?: string; tags?: string[] }): Promise<ResApplicantDetail> =>
    w
      .post(
        {
          applicant_name: data.name,
          email: data.email,
          phone: data.phone,
          tags: data.tags,
        },
        '/business/v1/applicant'
      )
      .json(),
}

export const editApplicantNotificationMutation = {
  mutationFn: (data: { pathId: string; isEmailNotificationOn: boolean }): Promise<ResApplicantDetail> =>
    w
      .post(
        {
          notification_mail: data.isEmailNotificationOn,
        },
        `/business/v1/applicant/${data.pathId}`
      )
      .json(),
}

export const editApplicantMutation = {
  mutationFn: (data: {
    pathId: string
    name: string
    email: string
    phone: string
    tags?: string[]
  }): Promise<ResApplicantDetail> =>
    w
      .post(
        {
          applicant_name: data.name,
          email: data.email,
          phone: data.phone,
          tags: data.tags,
        },
        `/business/v1/applicant/${data.pathId}`
      )
      .json(),
}

export const deleteApplicantsMutation = {
  mutationFn: (data: { pathIds: number[] }) =>
    w.json({ pathIds: data.pathIds }).delete(API_ENDPOINTS.business.v2.applicant.index).json(),
}
